// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5f5a2b51","796":"ca3eed7f"}[chunkId] + ".chunk.js";
};